import React from 'react';
import { toDisplayString, isBefore, isUnlimited } from '../lib/date.utils';
import { getContrastingTextColor } from '../lib/color.utils';
import Checkmark from '@material-ui/icons/Check';
import Clear from '@material-ui/icons/Clear';

const ICON_STYLE = { fontSize: '14px' };

const isHiddenLabel = label => label.toLowerCase() === 'hidden';

const isDateValid = date => isUnlimited(date) || isBefore(Date.now(), date);

const ValidityIcon = ({ isValid }) => (isValid ? <Checkmark style={ICON_STYLE} /> : <Clear style={ICON_STYLE} />);

export const CategoryBadge = ({ category, label, color, untilDate, isLiveView = false, showHidden = false }) => {
    const isHidden = label && isHiddenLabel(label);
    if (!label || (!showHidden && isHidden)) return null;

    const badgeStyle = color ? { backgroundColor: color, color: getContrastingTextColor(color) } : undefined;

    const showUntilInfo = untilDate && !isLiveView && !isUnlimited(untilDate);

    return (
        <span className="ckp-clearing-badge" style={badgeStyle}>
            {category ? (
                <>
                    <span className="ckp-clearing-badge__category">{category}:</span>
                    <span className="ckp-clearing-badge__label">{label}</span>
                </>
            ) : (
                <span className="ckp-clearing-badge__label">{label}</span>
            )}
            {showUntilInfo && (
                <>
                    <span className="ckp-clearing-badge__until">- until {toDisplayString(untilDate)}</span>
                    <ValidityIcon isValid={isDateValid(untilDate)} />
                </>
            )}
        </span>
    );
};

export default CategoryBadge;
